import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => (
  {
    root: {
      width: '100%',
      maxWidth: '120em',
      margin: '0 auto',
      padding: '5.5em 1.6em 4em'
    },

    container: {
      width: '100%',
      minWidth: "33.3em"
    },

    formContainer: {
      minHeight: "300px",
      backgroundColor: '#fff',
      borderRadius: 12,
      boxShadow: '0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    instructionsContainer: {
      padding: "2.3em 4em 0 4em",
      [theme.breakpoints.down('sm')]: {
        padding: "1.6em 1.6em 0 1.6em"
      },
    },

    instText: {
      paddingLeft: 0,
      paddingTop: 20,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: "0"
      },
    },

    text: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: "700",
      letterSpacing: "0.5px",
      lineHeight: "20px"
    },
    straightForward: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontWeight: "500",
      letterSpacing: "0.5px",
      lineHeight: "20px"
    },
    formInputContainer: {
    },
    inputContainer: {
      marginBottom: '3.9em',
      width: "75%",
      [theme.breakpoints.down('sm')]: {
        width: "100%"
      },
    },

    linkStyle: {
      color: '#1A4664',
      fontWeight: '700',
      textDecoration: 'underline',
      cursor: "pointer"
    },
    
    footerText: {
      color: '#4D4D4D',
      fontWeight: '700',
      // textDecoration: 'underline'
    },
    actionText: {
      color: "#000000",
      fontFamily: "Montserrat",
      fontSize: "16px",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      fontWeight: "600"
    },
    payoffQuote: {
      color: "#000000",
      fontFamily: "Montserrat",
      fontSize: "16px",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      fontWeight: "600",
      [theme.breakpoints.down('sm')]: {
        lineHeight: "20px",
        fontWeight: "500"
      },
    },
    paperless: {
      color: "#1A4664",
      fontFamily: "Montserrat",
      fontSize: "22px",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      fontWeight: "700",
      [theme.breakpoints.down('sm')]: {
        lineHeight: "20px",
        fontWeight: "600",
        fontSize: "16px"
      }
    },
    congrats: {
      color: "#000000",
      fontFamily: "Montserrat",
      fontSize: "24px",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      fontWeight: "600",
      [theme.breakpoints.down('sm')]: {
        lineHeight: "20px",
        fontWeight: "500",
        fontSize: "16px"
      }
    },

    activeHrs: {
      color: "#121D22",
      fontFamily: "Montserrat",
      fontSize: "16px",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      fontWeight: "500"
    },

    primaryColor: {
      backgroundColor: `${theme.primary}!important`,
    },

    divider: {
      padding: "0 15px"
    },

    underline: {
      textDecoration: 'none',
      color: '#535D6D',
      fontWeight: '600',
      fontSize: "16px",
      fontFamily: "Montserrat",
      letterSpacing: '0.6px',
      lineHeight: '19px',
    },

    mt10: {
      marginTop: '13px'
    },

    mbPhone: {
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '2em',
      },
    },

    paperlessStatement: {
      boxSizing: "border-box",
      border: "1px solid #D9D9D9",
      backgroundColor: "#F4F4F4",
      marginTop: "1em",
      paddingLeft: "1.2em",
      paddingRight: ".6em",
      paddingTop: "1.3em",
      borderRadius: '8px',
      marginBottom: '25px',
      [theme.breakpoints.down('sm')]: {
        height: "150px",
        paddingTop: "0px"
      }
    },

    infoText: {
      color: "#121D22",
      fontFamily: "Montserrat",
      fontSize: '14px',
      fontWeight: "400",
    },

    checkIcon: {
      width: 56,
      height: 56
    },

    chatIcon: {
      width: 200,
      height: 142
    },

    line: {
      border: '1px solid #D9D9D9'
    },
    
    checkImg: {
      width: 22,
      height: 22
    },

    infoTopIcon: {
      color: "#007FFF",
      width: 24,
      height: 24,
      marginRight: 10,
      marginLeft: 15
    },
 
    infoIcon: {
      color: "#E02020",
      width: 20,
      height: 20,
      marginRight: 10,
    },
    
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  
    title: {
      color: "rgba(0,0,0,0.87)",
      fontFamily: "Montserrat",
      fontSize: '2em',
      fontWeight: "400",
      textAlign: 'center',
      margin: 14,
    },
  
    cardBody: {
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
      padding: '12px 2em',
      boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      }
    },
  
    cardBody2: {
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
      padding: '2px 1.5em',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      }
    },
  
    statusTitle: {
      color: "#585757",
      fontFamily: "Montserrat",
      fontSize: 18,
      fontWeight: "700",
      padding: '3px 2px 2px 3px',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14
      }
    },
  
    statusBody: {
      color: "rgba(0,0,0,0.87)",
      fontFamily: "Montserrat",
      fontSize: '2em',
      fontWeight: "bold",
    },
  
    linkStyle: {
      color: "#25ABC7",
      fontFamily: "Montserrat",
      fontSize: '1.2em',
      fontWeight: "600",
      marginTop: 5,
    },
    singleFooterItem:{
      textAlign: 'center',
      padding: '0px 20px 20px'
    },
    btn: {
      width: 200,
      height: '38px',
      fontFamily: "Montserrat",
      fontSize: '14px',
      fontWeight: "600",
      [theme.breakpoints.down('sm')]: {
          fontSize: 14,
          height: '30px'
      }
    },
  
    flexBox: {
      display: 'flex',
      alignItems: 'center',
    },
    
    inputStyle: {
      color: "#535D6D",
      fontFamily: "Montserrat",
      fontSize: 16,
      fontWeight: "600"
    },
  
    labelStyle: {
      color: "#535D6D",
      fontFamily: "Montserrat",
      fontSize: 16,
      fontWeight: "400",
    },
  
    cardFooter: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: "#fff",
      padding: '8px 64px 0',
      [theme.breakpoints.down('sm')]: {
        padding: '8px 20px 0'
      },
    },
  
    footerItem: {
      marginBottom: 32,
      maxWidth: 200,
      marginRight: 18,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginRight: 6,
        marginLeft: 2
      },
    },
  
    boxMargin: {
      marginLeft: 75
    },
  
    paragraph: {
      color: "#121D22",
      fontFamily: "Montserrat",
      fontSize: 16,
      fontWeight: "600",
      marginBottom: 12,
      textAlign: 'center'
   },
  
   infoIcon: {
    paddingRight: "10px",
    fontSize: '30px',
    color: "#F59720"
  },
  
   proceed: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: 15,
    fontWeight: "700",
    marginBottom: 0,
    marginTop: 22,
    textAlign: 'center',
  },
  
  cardContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    marginTop: 15
  },
  
  imageContainer: {
    borderRadius: 4,
    padding: "6px",
    justifyContent: "center",
    [theme.breakpoints.down('sm')]: {
      display: "block"
    },
  },
  
  cardIcon: {
    width: 28,
    height: 22,
    color: "#EDB36A",
    marginTop: 22,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 10,
    },
  },
  
  cardContent: {
    display: 'flex'
  },
  
  cardTitle: {
    color: "#000000",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: '20px',
    letterSpacing: '0.15px',
    linHheight: '24px',
  },
    
  note: {
    color: 'rgba(0,0,0,0.6)',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '0.4px',
    lineHeight: '15px',
    marginTop: '5px',
    marginBottom: '2px',
    paddingLeft: '2px'
  },
  
  rating: {
    padding: '5px',
    borderRadius: '50%',
    height: '32px',
    width: '28px',
    display: "inline-block",
    marginLeft: 26,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10
     },
  },
  
  ratingText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '700',
  },
  
  textareaSection: {
    paddingTop: '20px',
    '& .MuiFormLabel-root': {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '15px'
    },
  },
  
  textArea: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 500,
    width: '100%',
    padding: "10px",
    height: '56px',
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    borderRadius: '4px',
    border: '1px solid #9E9E9E',
    "&::placeholder": {    
      fontSize: '14px', 
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '1rem',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      lineHeight: 1
     }
  },
  
  sliderLabel:{
    display: 'flex',
    padding: '12px 0px',
    justifyContent: 'space-between',
    color: '#121D22',
    fontSize: 12,
    fontFamily: "Montserrat",
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
       padding: '12px 24px 12px 0px'
    },
  },
  
  sliderText: {
    maxWidth: '60px'
  },

  singleLoanFooter: {
    textAlign: 'center',
    padding: '20px 20px 36px'
  }
  
  }
));
